import React from "react";

const ACCENT = "#ce0047";

type Props = {
  isOpen: boolean;
  panelWidthPx: number;
  onToggle: () => void;
  positioning?: "absolute" | "fixed";
  isLegend?: boolean; // Para distinguir entre formulario (izquierda) y leyenda (derecha)
};

const CollapseButton: React.FC<Props> = ({
  isOpen,
  panelWidthPx,
  onToggle,
  positioning = "absolute",
  isLegend = false,
}) => {
  // posición del botón
  let left: string;
  
  if (isLegend) {
    // Leyenda: izquierda cuando abierto, derecha cuando cerrado
    left = isOpen ? "-24px" : "0px"; // -24px para que esté pegado al margen izquierdo cuando abierto, 0px cuando cerrado
  } else {
    // Formulario: derecha cuando abierto, izquierda cuando cerrado  
    left = isOpen ? `${panelWidthPx}px` : "0px";
  }

  // Para la leyenda cerrada, usar fixed para que no se mueva con el contenedor
  const actualPositioning = isLegend && !isOpen ? "fixed" : positioning;
  
  // Ajustar la altura según el posicionamiento
  const topPosition = isLegend && !isOpen ? "76px" : "12px"; // 76px = 64px (top-16) + 12px (margen del botón)
  
  // Para la leyenda cerrada, posicionar a la derecha de la pantalla
  if (isLegend && !isOpen) {
    left = "calc(100vw - 24px)"; // Posición fija a la derecha de la pantalla
  }

  return (
    <button
      onClick={onToggle}
      title={isOpen ? "Colapsar" : "Expandir"}
      aria-label={isOpen ? "Colapsar panel" : "Expandir panel"}
      className={`${actualPositioning} z-50 pointer-events-auto flex items-center justify-center shadow-lg`}
      style={{
        left,
        top: topPosition,
        background: ACCENT,
        color: "white",
        width: "24px",
        height: "44px",
        padding: "0px",
        margin: "0px",
        border: "none",
        boxSizing: "content-box",
        borderRadius: isLegend ? "6px 0px 0px 6px" : "0px 6px 6px 0px" // Leyenda: izquierdas redondeadas, Formulario: derechas redondeadas
      }}
    >
      {/* Triángulo blanco fijo */}
      <div
        className="w-0 h-0"
        style={{
          borderTop: "5px solid transparent",
          borderBottom: "5px solid transparent",
          borderLeft: isLegend ? "8px solid white" : "8px solid white", // Ambos apuntan hacia la izquierda
        }}
      />
    </button>
  );
};

export default CollapseButton;
